export const SQL_DATE_FORMAT = 'yyyy-MM-dd';
export const FAQ_EDIBLE_REWARDS_ID = 7;
